import { StorageKeys } from './storageKeys';
export const getApolloSessionStorageKey = () => {
    const sessionStorageData = sessionStorage.getItem(StorageKeys.ApolloSession);
    if (sessionStorageData) {
        try {
            return JSON.parse(sessionStorageData);
        }
        catch (error) {
            console.error('Error parsing session storage data:', error);
        }
    }
    return {};
};
export const setApolloSessionStorageKey = (sessionStorageData) => {
    sessionStorage.setItem(StorageKeys.ApolloSession, JSON.stringify(sessionStorageData));
};
